function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 112,
  height: 29,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M33.343 19.89c0 1.865 1.383 3.039 2.996 3.039 1.635 0 2.934-1.237 2.934-3.04 0-1.864-1.299-3.017-2.934-3.017-1.613 0-2.996 1.216-2.996 3.018m-.168-9.472v5.72c.608-1.068 2.305-1.655 3.395-1.655 3.018 0 5.26 1.844 5.26 5.407 0 3.395-2.284 5.407-5.323 5.407-1.257 0-2.536-.42-3.332-1.656l-.168 1.425h-2.389V10.418ZM45.414 25.066H42.88V10.417h2.535zM54.614 18.695c-.167-1.34-1.215-2.011-2.682-2.011-1.383 0-2.515.67-2.892 2.011zm-5.616 2.117c.168 1.278 1.278 2.2 3.08 2.2.944 0 2.18-.356 2.767-.963l1.635 1.613c-1.09 1.132-2.871 1.677-4.443 1.677-3.563 0-5.68-2.2-5.68-5.512 0-3.143 2.138-5.407 5.491-5.407 3.458 0 5.617 2.138 5.218 6.392zM65.806 25.066V19.66c0-1.571-.86-2.766-2.494-2.766-1.572 0-2.64 1.32-2.64 2.892v5.281h-2.537V14.714h2.285l.168 1.404c1.047-1.027 2.095-1.551 3.395-1.551 2.43 0 4.38 1.823 4.38 5.071v5.428zM71.8 19.89c0 1.802 1.3 3.039 2.934 3.039 1.613 0 2.997-1.174 2.997-3.04 0-1.801-1.384-3.017-2.997-3.017-1.635 0-2.934 1.153-2.934 3.018m8.655-9.472v14.648h-2.389l-.168-1.425c-.796 1.237-2.074 1.656-3.332 1.656-3.038 0-5.323-2.012-5.323-5.407 0-3.563 2.243-5.407 5.26-5.407 1.09 0 2.788.587 3.395 1.656v-5.721zM82.323 18.364h5.104v2.348h-5.104zM97.361 18.695c-.168-1.34-1.215-2.011-2.682-2.011-1.384 0-2.515.67-2.892 2.011zm-5.616 2.117c.167 1.278 1.278 2.2 3.08 2.2.943 0 2.18-.356 2.767-.963l1.634 1.613c-1.09 1.132-2.87 1.677-4.443 1.677-3.562 0-5.679-2.2-5.679-5.512 0-3.143 2.138-5.407 5.49-5.407 3.459 0 5.617 2.138 5.219 6.392zM103.02 19.89c0 1.802 1.3 3.039 2.934 3.039 1.613 0 2.997-1.174 2.997-3.04 0-1.801-1.384-3.017-2.997-3.017-1.635 0-2.934 1.153-2.934 3.018m8.655-9.472v14.648h-2.389l-.168-1.425c-.796 1.237-2.074 1.656-3.332 1.656-3.039 0-5.323-2.012-5.323-5.407 0-3.563 2.242-5.407 5.26-5.407 1.09 0 2.787.587 3.395 1.656v-5.721z",
  style: {
    fill: "#1b296d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.153223
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.422 8.263A9.73 9.73 0 0 0 9.54 11.11c.93.18 1.799.528 2.575 1.013a7.27 7.27 0 0 1 4.307-1.409c4.03 0 7.308 3.278 7.308 7.308s-3.279 7.308-7.308 7.308a7.26 7.26 0 0 1-3.449-.867 7.6 7.6 0 0 1-2.409 1.36 9.7 9.7 0 0 0 5.858 1.958c5.38 0 9.758-4.378 9.758-9.759 0-5.38-4.377-9.759-9.758-9.759",
  style: {
    fill: "#633e98",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.153223
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.412 13.871a5.24 5.24 0 0 0-2.547-.536 9.7 9.7 0 0 0-1.202 4.687c0 2.184.721 4.202 1.938 5.83a5.24 5.24 0 0 0 2.445-.885 7.28 7.28 0 0 1-1.932-4.945c0-1.54.48-2.971 1.298-4.15",
  style: {
    fill: "#633e98",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.153223
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.6 23.852q-.253.024-.513.025a5.28 5.28 0 0 1-5.273-5.274 5.28 5.28 0 0 1 5.05-5.268A9.8 9.8 0 0 1 9.54 11.11a7.6 7.6 0 0 0-1.453-.14c-4.209 0-7.633 3.424-7.633 7.633 0 4.21 3.424 7.634 7.633 7.634.867 0 1.7-.147 2.477-.415a9.8 9.8 0 0 1-1.964-1.97M10.412 13.871a5.28 5.28 0 0 1 2.95 4.732 5.27 5.27 0 0 1-2.316 4.363 7.4 7.4 0 0 0 1.927 1.497 7.62 7.62 0 0 0 2.748-5.86 7.64 7.64 0 0 0-3.606-6.48 7.4 7.4 0 0 0-1.703 1.748",
  style: {
    fill: "#00bdf2",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.153223
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.046 22.966a5.24 5.24 0 0 1-2.445.886 9.8 9.8 0 0 0 1.963 1.97 7.6 7.6 0 0 0 2.41-1.359 7.4 7.4 0 0 1-1.928-1.497M7.865 13.335q.111-.005.222-.005a5.24 5.24 0 0 1 2.325.541 7.4 7.4 0 0 1 1.703-1.748A7.6 7.6 0 0 0 9.54 11.11a9.8 9.8 0 0 0-1.675 2.225",
  style: {
    fill: "#1b296d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.153223
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.138 6.711s-.051-5.44 4.826-5.483c0 0 .79 5.138-4.826 5.483",
  style: {
    fill: "#633e98",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.153223
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.46 9.744S2.288 8.54 3.37 4.798c0 0 4.11.57 3.09 4.946",
  style: {
    fill: "#00bdf2",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.153223
  }
}));
export { SvgLogo as ReactComponent };
export default __webpack_public_path__ + "4cd87c2fd825a6190421c8600985dcd2.svg";